// extracted by mini-css-extract-plugin
export var background = "_6a-0";
export var container = "_6a-1";
export var contentItem = "_6a-7";
export var extendedWarranty = "_6a-5";
export var link = "_6a-d";
export var modal = "_6a-b";
export var modalCloseButton = "_6a-9";
export var modalContent = "_6a-3";
export var modalContentMain = "_6a-6";
export var modalImageLogo = "_6a-8";
export var modalLogo = "_6a-a";
export var modalSideImage = "_6a-4";
export var preview = "_6a-c";
export var redoModal = "_6a-2";